'use client';
import { ReactNode } from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';

interface TabContentProps {
  id: string;
  labelledBy: string;
  active: boolean;
  children: ReactNode;
  className?: string;
}

const TabContent = ({
  id,
  labelledBy,
  active,
  children,
  className = ''
}: TabContentProps) => {
  if (!active) return null;
  
  return (
    <div
      role="tabpanel"
      id={id}
      aria-labelledby={labelledBy}
      className={classNames(
        'tw-w-full',
        className
      )}
      tabIndex={0}
    >
      {children}
    </div>
  );
};

export default TabContent;